import React from 'react'
import styled from '@emotion/styled'

const H6 = styled.h6`
`

export default H6